import OrderInquiry from './order-inquiry.vue'
export default OrderInquiry
